declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}

type MetaParams = Record<string, string | number | boolean | Array<string | number>>;

export const metaTrack = (eventName: string, params?: MetaParams) => {
    if (typeof window === "undefined" || typeof window.fbq !== "function") {
        return;
    }

    window.fbq("track", eventName, params ?? {});
};

export const metaTrackCustom = (eventName: string, params?: MetaParams) => {
    if (typeof window === "undefined" || typeof window.fbq !== "function") {
        return;
    }

    window.fbq("trackCustom", eventName, params ?? {});
};

export {};
